"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.fetchPageData = fetchPageData;
exports.default = usePageData;
const react_1 = __importDefault(require("react"));
const page_data_utils_1 = require("~/helpers/page-data-utils");
// eslint-disable-next-line complexity
function replaceImageNumbersWithImageData(data) {
    return __awaiter(this, void 0, void 0, function* () {
        if (typeof data.image === 'number') {
            const json = yield (0, page_data_utils_1.fetchFromCMS)(`images/${data.image}`);
            data.image = json.file || (json.meta || {}).download_url;
        }
        for (const prop of Reflect.ownKeys(data)) {
            if (typeof data[prop] === 'object' && data[prop] !== null) {
                yield replaceImageNumbersWithImageData(data[prop]);
            }
        }
    });
}
function fetchDataAndExpandImages(slug, preserveWrapping) {
    return __awaiter(this, void 0, void 0, function* () {
        const data = yield (0, page_data_utils_1.fetchFromCMS)(slug, preserveWrapping);
        yield replaceImageNumbersWithImageData(data);
        return data;
    });
}
function fetchPageData(slug, preserveWrapping, noCamelCase) {
    const camelCaseOrNot = noCamelCase ? (obj) => obj : page_data_utils_1.camelCaseKeys;
    return fetchDataAndExpandImages(slug, preserveWrapping).then(camelCaseOrNot);
}
function usePageData(slug, preserveWrapping = false, noCamelCase = false) {
    const [data, setData] = react_1.default.useState();
    react_1.default.useEffect(() => {
        fetchPageData(slug, preserveWrapping, noCamelCase).then(setData);
    }, [slug, preserveWrapping, noCamelCase]);
    return data;
}
